import { computed, ref } from 'vue'

// Exported only to support RTLPlugin, don't modify it directly, use enableRTL/disableRTL instead
export const _isRTLEnabled = ref(false)

export const isRTL = computed(() => _isRTLEnabled.value)

export function enableRTL () {
    _isRTLEnabled.value = true

    document.body.classList.add('rtl')
    document.documentElement.dir = 'rtl'

    // Temporary solution to support RTLPlugin, delete after RTLPlugin is removed
    window.postMessage(
        {
            type: 'direction',
            value: 'rtl'
        },
        '*'
    )
}

export function disableRTL () {
    _isRTLEnabled.value = false

    document.body.classList.remove('rtl')
    document.documentElement.dir = 'ltr'

    // Temporary solution to support RTLPlugin, delete after RTLPlugin is removed
    window.postMessage(
        {
            type: 'direction',
            value: 'ltr'
        },
        '*'
    )
}

